/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React from 'react';
import { Box, Flex, Image } from 'chakra-v3';
import { Text } from '../../components/Text';
import { Button } from '../../components/buttons/Index';
import { MdOutlineOpenInNew } from 'react-icons/md';
import karyaEvalsLogo from '../../assets/karya_evals_logo.svg';
import { EVALS_PLATFORM_URL } from '../../utils/env';

const SamikshaFooter: React.FC = () => {

  return (
    <Box
      bg="#0a313c"
      w="100%"
      h={{ base: 'auto', md: '211px' }}
      py={{ base: 8, md: 0 }}
      px={{ base: 4, sm: 6, md: 10, lg: 20, xl: '208px' }}
    >
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align={{ base: 'flex-start', md: 'center' }}
        gap={{ base: 6, md: 0 }}
        maxW="1440px"
        mx="auto"
        w="100%"
        h={{ base: 'auto', md: '100%' }}
        position="relative"
      >
        {/* Left Side - Logo */}
        <Box
          display="flex"
          alignItems="center"
          cursor="pointer"
          onClick={() => {
            if (typeof window !== 'undefined') {
              window.open(EVALS_PLATFORM_URL, '_blank', 'noopener,noreferrer');
            }
          }}
          _hover={{ opacity: 0.8 }}
          transition="opacity 0.2s"
        >
          <Image
            src={karyaEvalsLogo}
            alt="Karya Evals Logo"
            h={{ base: '40px', md: '64.894px' }}
            w={{ base: 'auto', md: '215px' }}
            objectFit="contain"
          />
        </Box>

        {/* Right Side - CTA Button */}
        <Button
          variant="cta"
          display="flex"
          gap={2}
          onClick={() => {
            if (typeof window !== 'undefined') {
              window.open('https://karya.in/contact/', '_blank', 'noopener,noreferrer');
            }
          }}
        >
          <Text
            fontFamily="body"
            fontSize={{ base: '16px', md: '16px', lg: '16px' }}
            fontWeight="600"
            lineHeight="1.4"
            letterSpacing="0.08px"
            color="#f6f6f6"
          >
            Contact us for your Evals needs
          </Text>
          <MdOutlineOpenInNew size={24} color="#f6f6f6" />
        </Button>
      </Flex>
    </Box>
  );
};

export default SamikshaFooter;
